<template>
  <v-container pa-0 ma-0 style="display: contents">
    <div
      v-for="(item, index) in additionalInformation"
      :key="index"
      :class="[ $vuetify.breakpoint.xsOnly ? 'mx-0' : 'mx-2']"
    >
      <v-list class="main pa-1 d-flex pb-3">
        <v-list-tile-action class="my-0 py-0" style="min-width: 22px; max-width: 22px">
          <v-icon
            v-if="item.FIO"
            :color="index ? 'orange' : 'green'"
          >{{!index ? 'person' : 'directions_run'}}</v-icon>
          <v-icon color="black" v-if="item.TelephoneNumber">phone</v-icon>
          <v-icon color="info" v-if="item.Email">local_post_office</v-icon>
        </v-list-tile-action>

        <v-list-tile-content class="text-xs-center pl-2">
          <v-list-tile-title v-if="item.FIO">{{item.FIO}}</v-list-tile-title>
          <v-list-tile-title v-if="item.TelephoneNumber">
            <a :href="callTo(item.TelephoneNumber)" class="blue--text">{{ item.TelephoneNumber }}</a>
          </v-list-tile-title>
          <v-list-tile-title v-if="item.Email">
            <a :href="mailTo(item.Email)" class="blue--text">{{ item.Email }}</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "workrequest-additional-info",
  props: {
    workRequest: Object
  },
  mounted() {
    this.updateAdditionalInformation({
      workRequestId: this.workRequest.IdApplication
    });
  },
  methods: {
    ...mapActions(["updateAdditionalInformation"]),
    callTo(number) {
      return "tel:" + number;
    },
    mailTo(email) {
      return "mailto:" + email;
    }
  },
  computed: {
    additionalInformation() {
      return this.$store.state.workRequests.additionalInformation;
    }
  }
};
</script>

<style></style>